import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class IconsService {
  constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {}

  loadIcons(): void {
    this.loadIcon('dashboard', '/assets/svg/icons/dashboard.svg');
    this.loadIcon('reports', '/assets/svg/icons/reports.svg');
    this.loadIcon('info', '/assets/svg/icons/info.svg');
    this.loadIcon('search', '/assets/svg/icons/search.svg');
    this.loadIcon('notification-bell', '/assets/svg/icons/notification-bell.svg');
    this.loadIcon('notification', '/assets/svg/icons/notification.svg');
    this.loadIcon('cancel', '/assets/svg/icons/cancel.svg');
    this.loadIcon('calendar', '/assets/svg/icons/dark-cal.svg');
    this.loadIcon('printer', '/assets/svg/icons/printer.svg');
    this.loadIcon('export', '/assets/svg/icons/export.svg');
    this.loadIcon('archive', '/assets/svg/icons/archive.svg');
    this.loadIcon('forward-mobile', '/assets/svg/icons/forward-mobile.svg');
    this.loadIcon('union', '/assets/svg/icons/Union.svg');
    this.loadIcon('delete-ic-white', '/assets/svg/icons/delete_white.svg');
    this.loadIcon('cloud-download', '/assets/svg/icons/cloud-download.svg');
    this.loadIcon('plus-round', '/assets/svg/icons/plus-round.svg');
    this.loadIcon('minus-round', '/assets/svg/icons/minus-round.svg');
    this.loadIcon('site-management', '/assets/svg/icons/site-management.svg');
    this.loadIcon('hauler-management', '/assets/svg/icons/hauler-management.svg');
    this.loadIcon('menu-company-profile', '/assets/svg/icons/menu-company-profile.svg');
    this.loadIcon('edit-icon', '/assets/svg/icons/edit-icon.svg');
    this.loadIcon('addcircle-wth-bg', '/assets/svg/icons/addcircle_wth_bg.svg');
  }

  private loadIcon(iconName: string, linkRef: string): void {
    this.iconRegistry.addSvgIcon(iconName, this.sanitizer.bypassSecurityTrustResourceUrl(linkRef));
  }
}
